module.exports = __webpack_public_path__ + "img/easy_digest.78d53e39.jpg";